<template>
  <div
    id="main-view"
    class="d-flex flex-column"
    :class="{ 'empresa-page': $route.name === 'EmpresaConfig', 'policy-page': ['NovaPoliticaCobranca', 'EditarPoliticaCobranca', 'DetalharPoliticaCobranca'].includes($route.name) }"
  >
    <!-- Header -->
    <header class="custom-header">
      <div class="d-flex align-items-center justify-content-between w-100 px-3">
        <!-- Logo -->
        <div class="logo d-flex align-items-center">
          <router-link to="/dashboard">
            <img
              v-if="$globalState.logoPath"
              :src="$globalState.logoPath"
              alt="Logomarca"
              class="header-logo"
            />
          </router-link>
        </div>

        <!-- Sidebar Toggle Button -->
        <button
          @click="toggleSidebar"
          class="btn btn-light toggle-sidebar-btn"
          aria-label="Exibir/Ocultar Menu"
        >
          <i :class="isSidebarVisible ? 'bi bi-chevron-left' : 'bi bi-chevron-right'"></i>
        </button>

        <!-- User Info (à direita) -->
        <div class="user-info d-flex align-items-center ms-auto position-relative" ref="userMenuRoot">
          <button class="btn btn-light d-flex align-items-center"
                  @click.stop="userMenuOpen = !userMenuOpen"
                  aria-haspopup="menu"
                  aria-expanded="userMenuOpen ? 'true' : 'false'">
            {{ isLoading
                ? 'Carregando...'
                : ($globalState.userName + ($globalState.userProfile ? ' (' + $globalState.userProfile + ')' : ''))
            }}
            <i class="bi bi-caret-down-fill ms-1"></i>
          </button>

          <ul v-if="userMenuOpen" class="dropdown-menu-user" role="menu">
            <li v-if="showChangePassword">
              <button class="dropdown-item dropdown-item-compact" @click="openChangePassword">
                Alterar senha
              </button>
            </li>
            <li>
              <button class="dropdown-item dropdown-item-compact text-danger" @click="logout">
                <i class="bi bi-box-arrow-right me-2"></i> Sair
              </button>
            </li>
          </ul>
        </div>

      </div>
    </header>

    <div class="d-flex flex-grow-1">
      <!-- Sidebar -->
      <aside
        class="sidebar"
        :class="{ 'sidebar-hidden': !isSidebarVisible }"
      >
        <!-- Conteúdo da Sidebar -->
        <div v-if="!isLoginPage" class="sidebar bg-primary text-light vh-100 p-3">
          <nav>
            <ul class="nav flex-column">
              <li class="nav-item">
                <router-link to="/dashboard" class="nav-link text-light">Dashboard</router-link>
              </li>
              <!-- Menu Gestão -->
              <li class="nav-item" v-if="acessoRelatorios.gestao">
                <span class="nav-link text-light main-menu" @click="toggleMenu('gestao')">Gestão</span>
                <ul v-if="menus.gestao" class="nav flex-column submenu">
                  <li v-if="acessoRelatorios.graficos">
                    <span class="nav-link text-light sub-menu" @click="toggleSubmenu('graficos')">Gráficos</span>
                    <ul v-if="submenus.graficos" class="nav flex-column submenu">
                      <!-- <li><router-link to="/graficos/visao-geral" class="nav-link text-light">Visão Geral</router-link></li> -->
                      <li v-if="acessoRelatorios.grupoGraficos('Financeiros')">
                        <router-link to="/gestao/graficos/financeiros" class="nav-link text-light">Financeiros</router-link>
                      </li>

                      <li v-if="acessoRelatorios.grupoGraficos('Operacionais')">
                        <router-link
                          v-if="hasFeature('GRAFICO_PROSPECCAO_MATRICULAS')"
                          to="/gestao/graficos/operacionais"
                          class="nav-link text-light"
                        >
                          Operacionais
                        </router-link>

                        <span
                          v-else
                          class="nav-link text-light nav-link-disabled"
                          :title="getFeatureMessage('GRAFICO_PROSPECCAO_MATRICULAS')"
                          @click="handleBlockedFeature('GRAFICO_PROSPECCAO_MATRICULAS')"
                        >
                          Operacionais
                          <i class="bi bi-lock-fill ms-2"></i>
                        </span>
                      </li>

                      <li v-if="acessoRelatorios.grupoGraficos('Comerciais')">
                        <router-link to="/gestao/graficos/comerciais" class="nav-link text-light">Comerciais</router-link>
                      </li>
                    </ul>
                  </li>

                  <li v-if="acessoRelatorios.relatorios">
                    <router-link to="/gestao/relatorios" class="nav-link text-light">Relatórios</router-link>
                  </li>
                </ul>
              </li>

              <!-- Menu Cadastros -->
              <li class="nav-item" v-if="hasPermission('menu_cadastro')">
                <span class="nav-link text-light main-menu" @click="toggleMenu('cadastros')">Cadastros</span>
                <ul v-if="menus.cadastros" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_animais')">
                    <router-link to="/cadastros/animais" class="nav-link text-light">Animais</router-link>
                  </li>
                  <li v-if="hasPermission('listar_brindes')">
                    <router-link to="/cadastros/brindes" class="nav-link text-light">Brindes</router-link>
                  </li>
                  <li v-if="hasPermission('listar_cargos_funcionarios')">
                    <router-link to="/cadastros/cargos-funcionarios" class="nav-link text-light">Cargos de Funcionários</router-link>
                  </li>
                  <li v-if="hasPermission('listar_categorias_planos')">
                    <router-link to="/cadastros/categorias-de-planos" class="nav-link text-light">Categorias de Planos</router-link>
                  </li>
                  <li v-if="hasPermission('listar_categorias_produtos')">
                    <router-link to="/cadastros/categorias-de-produtos" class="nav-link text-light">Categorias de Produtos</router-link>
                  </li>
                  <li v-if="hasPermission('listar_convenios')">
                    <router-link to="/cadastros/convenios" class="nav-link text-light">Convênios</router-link>
                  </li>
                  <li v-if="hasPermission('listar_descontos')">
                    <router-link to="/cadastros/descontos" class="nav-link text-light">Descontos</router-link>
                  </li>

                  <li v-if="hasPermission('listar_funcionarios')">
                    <router-link to="/cadastros/funcionarios" class="nav-link text-light">Funcionários</router-link>
                  </li>
                  <li v-if="hasPermission('listar_niveis_turmas')">
                    <router-link to="/cadastros/niveis-turmas" class="nav-link text-light">Níveis de Turmas</router-link>
                  </li>
                  <li v-if="hasPermission('listar_periodos_avaliacoes')">
                    <router-link to="/cadastros/avaliacoes-periodos" class="nav-link text-light">Período de Avaliações</router-link>
                  </li>
                  <li v-if="hasPermission('listar_pessoas_fisicas')">
                    <router-link to="/cadastros/pessoas-fisicas" class="nav-link text-light">Pessoas Físicas</router-link>
                  </li>
                  <li v-if="hasPermission('listar_pessoas_juridicas')">
                    <router-link to="/cadastros/pessoas-juridicas" class="nav-link text-light">Pessoas Jurídicas</router-link>
                  </li>
                  <li v-if="hasPermission('listar_planos_matriculas')">
                    <router-link to="/cadastros/planos-matriculas" class="nav-link text-light">Planos de Matrículas</router-link>
                  </li>
                  <li v-if="hasPermission('listar_produtos')">
                    <router-link
                      v-if="hasFeature('LOJA')"
                      to="/cadastros/produtos"
                      class="nav-link text-light"
                    >
                      Produtos e Estoque
                    </router-link>

                    <span
                      v-else
                      class="nav-link text-light nav-link-disabled"
                      :title="getFeatureMessage('LOJA')"
                      @click="handleBlockedFeature('LOJA')"
                    >
                      Produtos e Estoque
                      <i class="bi bi-lock-fill ms-2"></i>
                    </span>
                  </li>
                  <li v-if="hasPermission('listar_tipos_planos')">
                    <router-link to="/cadastros/tipos-planos" class="nav-link text-light">Tipos de Planos</router-link>
                  </li>
                  <li v-if="hasPermission('listar_turmas')">
                    <router-link to="/cadastros/turmas" class="nav-link text-light">Turmas</router-link>
                  </li>
                </ul>
              </li>

              <!-- Menu Operacional -->
              <li class="nav-item" v-if="hasPermission('menu_operacional')">
                <span class="nav-link text-light main-menu" @click="toggleMenu('operacional')">Operacional</span>
                <ul v-if="menus.operacional" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_aniversariantes')">
                    <router-link to="/operacional/aniversariantes" class="nav-link text-light">Aniversariantes</router-link>
                  </li>
                  <li v-if="hasPermission('listar_aulas_avulsas')">
                    <router-link to="/operacional/aulas-avulsas" class="nav-link text-light">Aulas Avulsas</router-link>
                  </li>
                  <li v-if="hasPermission('listar_aulas_reposicao')">
                    <router-link to="/operacional/aulas-reposicao" class="nav-link text-light">Aulas de Reposição</router-link>
                  </li>
                  <li v-if="hasPermission('listar_avaliacoes_desempenho')">
                    <router-link to="/operacional/avaliacoes-desempenho" class="nav-link text-light">Avaliações de Desempenho</router-link>
                  </li>

                  <span v-if="hasPermission('listar_emarketing_respativos') || hasPermission('listar_emarketing_respinativos')" class="nav-link text-light sub-menu" @click="toggleSubmenu('emarketing')">E-Marketing</span>
                  <ul v-if="submenus.emarketing" class="nav flex-column submenu">
                    <li v-if="hasPermission('listar_emarketing_respativos')">
                      <router-link to="/operacional/emarketing-respativos" class="nav-link text-light">Responsáveis Ativos</router-link>
                    </li>
                    <li v-if="hasPermission('listar_emarketing_respinativos')">
                      <router-link to="/operacional/emarketing-respinativos" class="nav-link text-light">Responsáveis Inativos</router-link>
                    </li>
                  </ul>


                  <li v-if="hasPermission('listar_matriculas')">
                    <router-link to="/operacional/matriculas" class="nav-link text-light">Matrículas</router-link>
                  </li>

                  <li v-if="hasPermission('listar_posvendas')">
                    <router-link
                      v-if="hasFeature('POSVENDAS')"
                      to="/operacional/posvendas"
                      class="nav-link text-light"
                    >
                      Pós-vendas
                    </router-link>

                    <span
                      v-else
                      class="nav-link text-light nav-link-disabled"
                      :title="getFeatureMessage('POSVENDAS')"
                      @click="handleBlockedFeature('POSVENDAS')"
                    >
                      Pós-vendas
                      <i class="bi bi-lock-fill ms-2"></i>
                    </span>
                  </li>

                  <li v-if="hasPermission('listar_prospeccao')">
                    <router-link
                      v-if="hasFeature('PROSPECCAO')"
                      to="/operacional/prospeccao"
                      class="nav-link text-light"
                    >
                      Prospecções
                    </router-link>

                    <span
                      v-else
                      class="nav-link text-light nav-link-disabled"
                      :title="getFeatureMessage('PROSPECCAO')"
                      @click="handleBlockedFeature('PROSPECCAO')"
                    >
                      Prospecções
                      <i class="bi bi-lock-fill ms-2"></i>
                    </span>
                  </li>

                  <li v-if="hasPermission('listar_protocolos_queda')">
                    <router-link to="/operacional/protocolos-queda" class="nav-link text-light">Protocolos de Queda</router-link>
                  </li>
                  <!-- <li v-if="hasPermission('listar_saidas_animais')">
                    <router-link to="/operacional/saidas-animais" class="nav-link text-light">Saídas de Animais</router-link>
                  </li> -->
                  <li v-if="hasPermission('listar_supervisoes')">
                    <router-link to="/operacional/supervisoes" class="nav-link text-light">Supervisões</router-link>
                  </li>
                  <li v-if="hasPermission('listar_turmas_instrutor')">
                    <router-link to="/operacional/turmas-instrutor" class="nav-link text-light">Turmas do Instrutor</router-link>
                  </li>
                </ul>
              </li>

              <!-- Menu Loja -->
              <li class="nav-item" v-if="hasPermission('menu_loja')">
                <span
                  v-if="hasFeature('LOJA')"
                  class="nav-link text-light main-menu"
                  @click="toggleMenu('loja')"
                >
                  Loja
                </span>

                <span
                  v-else
                  class="nav-link text-light main-menu nav-link-disabled"
                  :title="getFeatureMessage('LOJA')"
                  @click="handleBlockedFeature('LOJA')"
                >
                  Loja
                  <i class="bi bi-lock-fill ms-2"></i>
                </span>

                <ul v-if="menus.loja && hasFeature('LOJA')" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_entradas')">
                    <router-link to="/loja/entradas" class="nav-link text-light">Entradas de Produtos</router-link>
                  </li>
                  <li v-if="hasPermission('listar_vendas')">
                    <router-link to="/loja/vendas" class="nav-link text-light">Vendas de Produtos</router-link>
                  </li>
                </ul>
              </li>

              <!-- Menu Financeiro -->
              <li class="nav-item" v-if="hasPermission('menu_financeiro')">
                <span class="nav-link text-light main-menu" @click="toggleMenu('financeiro')">Financeiro</span>
                <ul v-if="menus.financeiro" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_contas_financeiras')">
                    <router-link to="/financeiro/contas-financeiras" class="nav-link text-light">Contas Financeiras</router-link>
                  </li>
                  <li v-if="hasPermission('listar_conciliacao_bancaria')">
                    <router-link to="/financeiro/conciliacao-bancaria" class="nav-link text-light">
                      Conciliação Bancária
                    </router-link>
                  </li>
                  <li v-if="hasPermission('listar_despesas')">
                    <router-link to="/financeiro/despesas" class="nav-link text-light">Despesas</router-link>
                  </li>

                  <li v-if="showBoletosMenu">
                    <span class="nav-link text-light sub-menu" :class="{ active: boletosRouteActive }"
                      role="button" tabindex="0" :aria-expanded="submenus.boletos || boletosRouteActive"
                      @click="toggleSubmenu('boletos')" @keydown.enter="toggleSubmenu('boletos')">Boletos</span>
                    <ul v-if="submenus.boletos || boletosRouteActive" class="nav flex-column submenu">
                  <li
                    v-if="hasPermission('financeiro_cobrancas_visualizar')"
                  >
                    <router-link
                      to="/financeiro/cobrancas"
                      class="nav-link text-light"
                    >
                      Cobranças e Boletos
                    </router-link>
                  </li>

                  <li
                    v-if="hasPermission('financeiro_cobrancas_visualizar')"
                  >
                    <router-link
                      to="/financeiro/cobrancas/politicas"
                      class="nav-link text-light"
                    >
                      Políticas de Cobrança
                    </router-link>
                  </li>

                  <li
                    v-if="hasPermission('financeiro_cobrancas_configurar')"
                  >
                    <router-link
                      to="/financeiro/cobrancas/configuracoes"
                      class="nav-link text-light"
                    >
                      Configurações Bancárias
                    </router-link>
                  </li>
                    </ul>
                  </li>
                  <!-- <li>
                    <router-link to="/financeiro/despesas-liquidadas" class="nav-link text-light">Despesas Liquidadas</router-link>
                  </li> -->
                  <!-- <li>
                    <span class="nav-link text-light sub-menu" @click="toggleSubmenu('parametros')">Parâmetros de Pagamentos</span>
                    <ul v-if="submenus.parametros" class="nav flex-column submenu">
                      <li v-if="hasPermission('listar_parametros_operadores')">
                        <router-link to="/financeiro/parametros/operadores" class="nav-link text-light">Operadores</router-link>
                      </li>
                      <li v-if="hasPermission('listar_parametros_meios')">
                        <router-link to="/financeiro/parametros/meios" class="nav-link text-light">Meios</router-link>
                      </li>
                      <li v-if="hasPermission('listar_parametros_formas')">
                        <router-link to="/financeiro/parametros/formas" class="nav-link text-light">Formas</router-link>
                      </li>
                      <li v-if="hasPermission('listar_parametros_bandeiras')">
                        <router-link to="/financeiro/parametros/bandeiras" class="nav-link text-light">Bandeiras</router-link>
                      </li>
                      <li v-if="hasPermission('listar_parametros_tipos')">
                        <router-link to="/financeiro/parametros/tipos" class="nav-link text-light">Tipos</router-link>
                      </li>
                      <li v-if="hasPermission('listar_parametros_taxas')">
                        <router-link to="/financeiro/parametros/taxas" class="nav-link text-light">Taxas</router-link>
                      </li>
                    </ul>
                  </li> -->
                  <!-- <li>
                    <router-link to="/financeiro/pendencias" class="nav-link text-light">Pendências</router-link>
                  </li> -->
                  <li v-if="hasPermission('listar_planos_contas')">
                    <router-link to="/financeiro/planos-contas" class="nav-link text-light">Planos de Contas</router-link>
                  </li>

                    <span v-if="hasPermission('listar_receitas_gerais') || hasPermission('listar_receitas_planos')" class="nav-link text-light sub-menu" @click="toggleSubmenu('receitas')">Receitas</span>
                    <ul v-if="submenus.receitas" class="nav flex-column submenu">

                      <li v-if="hasPermission('listar_receitas_gerais')">
                        <router-link to="/financeiro/receitas-gerais" class="nav-link text-light">Gerais</router-link>
                      </li>
                      <li v-if="hasPermission('listar_receitas_planos')">
                        <router-link to="/financeiro/receitas-planos" class="nav-link text-light">Planos</router-link>
                      </li>
                    </ul>

                  <!-- <li>
                    <router-link to="/financeiro/receitas-recebidas" class="nav-link text-light">Receitas Recebidas</router-link>
                  </li> -->
                  <li v-if="hasPermission('listar_registros_financeiros')">
                    <router-link to="/financeiro/registros-financeiros" class="nav-link text-light">Registros Financeiros</router-link>
                  </li>
                  <li v-if="hasPermission('listar_subcontas')">
                    <router-link to="/financeiro/subcontas" class="nav-link text-light">Subcontas</router-link>
                  </li>

                  <li v-if="hasPermission('listar_transferencias_contas')">
                    <router-link to="/financeiro/transferencias-contas" class="nav-link text-light">
                      Transferências entre Contas
                    </router-link>
                  </li>

                  <li v-if="hasPermission('listar_valores')">
                    <router-link to="/financeiro/valores" class="nav-link text-light">Valores</router-link>
                  </li>
                </ul>
              </li>
              <!-- Menu Configurações -->
              <li class="nav-item" v-if="hasPermission('menu_configuracoes')">
                <span class="nav-link text-light main-menu" @click="toggleMenu('configuracoes')">Configurações</span>
                <ul v-if="menus.configuracoes" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_documentos')">
                    <router-link to="/configuracoes/documentos" class="nav-link text-light">Documentos</router-link>
                  </li>
                  <li v-if="hasPermission('alterar_empresa')">
                    <router-link to="/configuracoes/empresa" class="nav-link text-light">Empresa</router-link>
                  </li>
                  <li v-if="hasPermission('listar_formularios_avaliacoes')">
                    <router-link to="/configuracoes/formularios-avaliacoes" class="nav-link text-light">Formulários de Avaliações</router-link>
                  </li>

                  <li>
                    <span v-if="hasPermission('listar_parametros_categorias') || hasPermission('listar_parametros_blocos') || hasPermission('listar_parametros_questoes') || hasPermission('listar_parametros_opcoes')" class="nav-link text-light sub-menu" @click="toggleSubmenu('avaliacoes')">Parâmetros de Avaliações</span>
                    <ul v-if="submenus.avaliacoes" class="nav flex-column submenu">

                      <li v-if="hasPermission('listar_parametros_categorias')">
                        <router-link to="/configuracoes/parametros-avaliacoes/categorias" class="nav-link text-light">Categorias</router-link>
                      </li>

                      <li v-if="hasPermission('listar_parametros_blocos')">
                        <router-link to="/configuracoes/parametros-avaliacoes/blocos" class="nav-link text-light">Blocos de Questões</router-link>
                      </li>

                      <li v-if="hasPermission('listar_parametros_questoes')">
                        <router-link to="/configuracoes/parametros-avaliacoes/questoes" class="nav-link text-light">Questões</router-link>
                      </li>

                      <!-- <li v-if="hasPermission('listar_parametros_opcoes')">
                        <router-link to="/configuracoes/parametros-avaliacoes/opcoes" class="nav-link text-light">Opções das Questões</router-link>
                      </li> -->

                    </ul>
                  </li>

                  <li v-if="hasPermission('listar_perfis_usuarios')">
                    <router-link to="/configuracoes/perfis-de-usuarios" class="nav-link text-light">Perfis de Usuários</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/configuracoes/perfil-da-escola" class="nav-link text-light">Perfil da Escola</router-link>
                  </li> -->
                  <!-- <li>
                    <router-link to="/configuracoes/renovacao-antecipada" class="nav-link text-light">Renovação Antecipada</router-link>
                  </li> -->
                  <li v-if="hasPermission('listar_usuarios')">
                    <router-link to="/configuracoes/usuarios" class="nav-link text-light">Usuários</router-link>
                  </li>
                  <li v-if="hasPermission('listar_recessos')">
                    <router-link to="/configuracoes/recessos" class="nav-link text-light">Recessos</router-link>
                  </li>
                </ul>
              </li>
              <!-- Menu Ajuda -->
              <li class="nav-item" v-if="hasPermission('menu_ajuda')">
                <span class="nav-link text-light main-menu" @click="toggleMenu('ajuda')">Ajuda</span>
                <ul v-if="menus.ajuda" class="nav flex-column submenu">
                  <li v-if="hasPermission('listar_material')">
                    <router-link to="/ajuda/materiais" class="nav-link text-light">Materiais</router-link>
                  </li>
                  <li v-if="hasPermission('listar_videoaulas')">
                    <router-link to="/ajuda/videoaulas" class="nav-link text-light">Videoaulas - [Manuais]</router-link>
                  </li>
                  <!-- <li v-if="hasPermission('exibir_quiz')">
                    <router-link to="/ajuda/quiz" class="nav-link text-light">Quiz</router-link>
                  </li> -->
                  <!-- <li v-if="hasPermission('exibir_jogos')">
                    <router-link to="/ajuda/jogos" class="nav-link text-light">Cavalinho Saltador</router-link>
                  </li> -->
                  <!-- <li v-if="hasPermission('exibir_montador_pista')">
                    <router-link to="/ajuda/montador" class="nav-link text-light">Montador de Pista</router-link>
                  </li> -->
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      <!-- Main Content -->
      <div
        :class="[
          isLoginPage ? 'w-100' : 'main-content d-flex flex-column',
          isSidebarVisible ? '' : 'content-expanded'
        ]"
      >
        <!-- Breadcrumb -->
        <AppBreadcrumb />

        <!-- Conteúdo rolável -->
        <div class="content-wrapper flex-grow-1">
          <b-container fluid :class="[isLoginPage ? 'p-0' : 'p-4']">
            <p v-if="!podeAcessarRotaGestao" role="status" class="alert alert-secondary">{{ $globalState.permissionsLoaded ? 'Nenhum recurso autorizado nesta página de Gestão.' : 'Carregando permissões…' }}</p>
            <router-view v-else-if="podeAcessarRotaBoletos" />
            <p v-else role="status" class="alert alert-secondary">Boletos indisponíveis para consulta neste momento.</p>
          </b-container>
        </div>

        <!-- Footer -->
        <footer v-if="!isLoginPage" class="text-center py-3 bg-light custom-footer">
          <small>&copy; 2026 - TOQ Soluções - Khodr & Cabral</small>
        </footer>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <AlterarSenhaModal :show="changePasswordOpen" @close="changePasswordOpen = false" @success="onPasswordChanged" />

</template>

<script>
import { relatoriosAccess, gestaoRouteAllowed } from "@/utils/relatoriosAccess";
import { BContainer } from "bootstrap-vue-next";
import { mostrarMenuBoletos, podeAdministrarBoletos, rotaBoletosAtiva } from "@/utils/boletosCapability.mjs";
import axios from "@/services/axios";
import AppBreadcrumb from "@/components/AppBreadcrumb.vue";
import AlterarSenhaModal from "@/components/Conta/AlterarSenhaModal.vue";


export default {
  name: "App",
  components: {
    BContainer,
    AppBreadcrumb,
    AlterarSenhaModal,
  },
  computed: {
    podeAcessarRotaGestao() { return gestaoRouteAllowed(this.$globalState, this.$route); },
    acessoRelatorios() { return relatoriosAccess(this.$globalState); },
    podeAcessarRotaBoletos() {
      if (!this.boletosRouteActive) return true;
      const configurar = this.$route.path.startsWith('/financeiro/cobrancas/configuracoes');
      if (configurar) return podeAdministrarBoletos(this.boletosCapability, p => this.hasPermission(p));
      return this.showBoletosMenu && this.hasPermission('financeiro_cobrancas_visualizar');
    },
    showBoletosMenu() { return mostrarMenuBoletos(this.boletosCapability, p => this.hasPermission(p)); },
    boletosRouteActive() { return rotaBoletosAtiva(this.$route.path); },
    isLoginPage() {
      return this.$route.name === "Login";
    },
    logoPath() {
      return this.$utils.absoluteUploadUrl(this.$root.$logoPath || '');
    },
  },
  data() {
    return {
      isSidebarVisible: true,
      isMobile: false,
      isLoading: true,
      permissionsLoaded: false,
      boletosCapability: null,
      boletosRequest: 0,
      userPermissions: [],
      userName: "",
      menus: {
        gestao: false,
        cadastros: false,
        operacional: false,
        financeiro: false,
        configuracoes: false,
        ajuda: false,
      },
      submenus: {
        boletos: false,
        graficos: false,
        relatorios: false,
        "parametros-avaliacoes": false,
      },
      userMenuOpen: false,
      changePasswordOpen: false,
      // suposição simples: sempre true; se tiver SSO, setar false via /auth/user
      showChangePassword: true,
      docClickHandler: null,   // (antes: _onDocClick)
      resizeHandler: null,     // (antes: _onResize)
    };
  },
  watch: {
    '$route.path': { immediate: true, handler(path) {
      if (rotaBoletosAtiva(path)) { this.menus.financeiro = true; this.submenus.boletos = true; }
      this.fetchBoletosCapability();
    } }
  },
  created() {
    this.fetchUserDetails();
    this.fetchPermissions();
  },

  mounted() {
    window.addEventListener('boletos-capability-changed', this.fetchBoletosCapability);
    // inicial
    this.checkMobile();
    this.isSidebarVisible = !this.isMobile;

    // resize
    this.resizeHandler = () => this.checkMobile();
    window.addEventListener('resize', this.resizeHandler, { passive: true });

    // clique-fora (usa ref do container)
    this.docClickHandler = (e) => {
      const root = this.$refs.userMenuRoot; // << ref do container do menu
      if (this.userMenuOpen && root && !root.contains(e.target)) {
        this.userMenuOpen = false;
      }
    };
    // capture ajuda a fechar mesmo se outros handlers fizerem stopPropagation depois
    document.addEventListener('click', this.docClickHandler, true);
  },

  beforeUnmount() {
    window.removeEventListener('boletos-capability-changed', this.fetchBoletosCapability);
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.docClickHandler) {
      document.removeEventListener('click', this.docClickHandler, true);
      this.docClickHandler = null;
    }
  },

  methods: {
    async fetchBoletosCapability() {
      const request = ++this.boletosRequest;
      this.boletosCapability = null;
      if (!localStorage.getItem("token")) return;
      try {
        const { data } = await axios.get("/financeiro/cobrancas/capabilities");
        if (request === this.boletosRequest) this.boletosCapability = data;
      } catch { if (request === this.boletosRequest) this.boletosCapability = null; }
    },

    checkMobile() {
      this.isMobile = window.matchMedia("(max-width: 768px)").matches;
    },

    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    async fetchUserDetails() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("Token não encontrado. Redirecionando para login.");
          this.$router.push("/login");
          return;
        }
        const response = await axios.get(`/auth/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.name) {
          this.$globalState.userName = response.data.name;
          this.$globalState.userId = response.data.id;
        } else {
          console.error("Nome do usuário não encontrado na resposta.");
          this.$globalState.userName = "Usuário Desconhecido";
        }

        // Atualiza também o perfil do usuário
        if (response.data.profile) {
          this.$globalState.userProfile = response.data.profile;
        } else {
          console.error("Perfil do usuário não encontrado na resposta.");
          this.$globalState.userProfile = "Perfil Desconhecido";
        }

        if (response.data.company?.planoSistema) {
          this.$globalState.companyPlan = response.data.company.planoSistema;
        } else {
          this.$globalState.companyPlan = 'PREMIUM';
        }

        if (response.data.features) {
          this.$globalState.featureFlags = response.data.features;
        } else {
          this.$globalState.featureFlags = {};
        }

        this.$globalState.featuresLoaded = true;

        localStorage.setItem(
          'feature_flags',
          JSON.stringify(this.$globalState.featureFlags || {})
        );
        localStorage.setItem(
          'company_plan',
          this.$globalState.companyPlan || 'PREMIUM'
        );


      } catch (error) {
        console.error("Erro ao buscar detalhes do usuário:", error);
        this.$globalState.userName = "Erro ao carregar";
        this.$globalState.userProfile = "Erro ao carregar";
        this.$globalState.companyPlan = 'PREMIUM';
        this.$globalState.featureFlags = {};
        this.$globalState.featuresLoaded = true;
      } finally {
        this.isLoading = false;
      }
    },

    hasFeature(featureKey) {
      if (!this.$globalState.featuresLoaded) {
        return true;
      }

      return !!this.$globalState.featureFlags?.[featureKey]?.enabled;
    },

    getFeatureMessage(featureKey) {
      return this.$globalState.featureFlags?.[featureKey]?.message
        || 'Módulo exclusivo para o Plano Performance';
    },

    handleBlockedFeature(featureKey) {
      const message = this.getFeatureMessage(featureKey);

      if (typeof this.$alert === 'function') {
        this.$alert(message, 'Plano');
        return;
      }

      alert(message);
    },

    toggleMenu(menu) {
      this.menus[menu] = !this.menus[menu];
    },
    toggleSubmenu(submenu) {
      this.submenus[submenu] = !this.submenus[submenu];
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
    openChangePassword() {
      this.userMenuOpen = false;
      this.changePasswordOpen = true;
    },
    onPasswordChanged() {
      // opcional: forçar re-login se desejar
      // this.logout();
      this.$bvToast?.toast?.('Senha alterada com sucesso.', { variant: 'success' });
    },
  },
};
</script>

<style scoped>
/* Header */
.custom-header {
  width: 100%;
  height: 60px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
/* MainView.vue */
.header-logo {
  height: 55px;        /* antes: 40px */
  max-height: 56px;    /* garante que não encoste nas bordas do header */
  width: auto;
  object-fit: contain;
}
.user-info {
  display: flex;
  align-items: center;
}
.ms-auto {
  margin-left: auto !important;
}
.me-2 {
  margin-right: 0.5rem !important;
}

/* Sidebar */
#main-view .sidebar {
  width: 250px;
  height: calc(100vh - 60px);
  position: fixed;
  top: 60px;
  left: 0;
  background-color: #343a40 !important;
  color: #f8f9fa !important;
  transition: transform 0.3s ease-in-out;
  overflow-y: auto !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}
.sidebar-hidden {
  transform: translateX(-100%);
}

/* Main Content */
.main-content {
  margin-left: 250px;
  margin-top: 60px;
  height: calc(100vh - 60px); /* A altura disponível descontando o header */
  display: flex;
  flex-direction: column;
  padding: 20px; /* se desejar manter o padding interno */
  transition: margin-left 0.3s ease-in-out;
}

.custom-footer {
  position: fixed;
  bottom: 0px;     /* distância do rodapé até a borda inferior */
  right: 10px;      /* distância do rodapé até a borda direita */
  padding: 0px 6px; /* diminui o espaçamento interno (vertical e horizontal) */
  /* background-color: #fff; defina cor de fundo, se quiser contraste */
  /* z-index: 9999;    garante que fique sobre outros elementos */
  border-radius: 4px;
}

.b-container {
  flex-grow: 1;
}


.content-expanded {
  margin-left: 0;
}
.nav-link {
  color: #f8f9fa;
  font-weight: 500;
  padding: 10px 15px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.nav-link:hover {
  background-color: #495057;
  color: #ffffff;
}

/* Toggle Button */
.toggle-sidebar-btn {
  background-color: transparent;
  border: none;
  font-size: 20px;
}
.toggle-sidebar-btn i {
  color: #6c757d;
}
.toggle-sidebar-btn:hover i {
  color: #000;
}

/* Dropdown do usuário (escopado) */
.dropdown-menu-user {
  position: absolute;
  right: 0;
  top: 110%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  min-width: 220px;
  z-index: 1100;
  box-shadow: 0 4px 18px rgba(0,0,0,.12);

  /* remover bullets e espaços do UL */
  list-style: none;
  margin: 0;
  padding: 6px 0;
}

.dropdown-menu-user li {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Itens do dropdown (compactos) */
.dropdown-menu-user .dropdown-item {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  font-size: 0.95rem;
  line-height: 1.2;
  padding: 8px 12px; /* compacto */
}

.dropdown-menu-user .dropdown-item:hover {
  background: #f6f6f6;
}

.dropdown-menu-user .dropdown-item i {
  vertical-align: -1px; /* alinha ícone com o texto */
}

.dropdown-menu-user .dropdown-item.text-danger {
  color: #dc3545;
}

/* Botão gatilho (nome do usuário) */
.user-info .btn {
  font-size: 0.95rem;
  line-height: 1.2;
  padding: 6px 10px;
}

.nav-link-disabled {
  opacity: 0.65;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  user-select: none;
}

/* Keep the standard fixed footer; reserve its bottom strip outside the scroll area. */
.policy-page .main-content { min-width: 0; height: calc(100vh - 60px - 2rem); }
.policy-page .content-expanded { width: 100%; }
.policy-page .content-wrapper { flex-shrink: 0; min-width: 0; }
@media (max-width: 768px) {
  .policy-page .main-content { padding: 12px; }
  .policy-page .content-wrapper > .container-fluid { padding: 1rem 0 !important; }
}
/* Company module confirmation must stay readable and scrollable on narrow screens. */
.empresa-page .main-content { min-width: 0; height: calc(100vh - 60px - 2rem); }
.empresa-page .content-expanded { width: 100%; }
.empresa-page .content-wrapper { flex-shrink: 0; min-width: 0; }
@media (max-width: 768px) {
  .empresa-page .main-content { width: 100%; margin-left: 0; padding: 12px; }
  .empresa-page .content-wrapper > .container-fluid { padding: 1rem 0 !important; }
}
</style>
